import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const Residential = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Residential & Home Drone Cleaning - Flyby Shine</title>
                        <meta name="description" content="Make Your Home Shine with Our Advanced Drone-Assisted Pressure and Soft Washing Services!" />
                        <meta name="keywords" content="Drone Cleaning, Drone cleaning services, residential drone cleaning, home drone cleaning, hygienic drone cleaning, expert drone cleaning services, safe drone cleaning, thorough drone cleaning, professional drone cleaning, reliable drone cleaning, top-quality drone cleaning, drone cleaning services, drone cleaning solutions, drone cleaning experts" />
                        <meta property="og:image" content="/assets/residential.JPG" />
                    </>
                )}
            </MetaTagHandler>

            <NavBar dark={true} />
            <div style={{
                height: '30vh',
                minHeight: '320px'
            }} className="core-header vivify fadeIn duration-300 delay-100  inline-header-core">
                <span>Our Services</span>
                <h1>Residential & Home</h1>
                <p>
                    Make Your Home Shine with Our Advanced Drone-Assisted Pressure and Soft Washing Services!
                </p>
            </div>
            <div className="service-cards-list" data-aos="fade-up" data-aos-delay="100" style={{ marginTop: 75, justifyContent: 'center' }}>
                <Link to="/drone-softwash-pressurewash-residential" className="service-card" >
                    <img src="/assets/residential.JPG" alt="A drone cleaning a commercial building" />
                    <h2>Drone Soft Wash & Pressure Wash</h2>
                    <p>
                        Elevate Your Home's Appeal with Our Advanced Drone-Assisted Pressure and Soft Washing Services.
                    </p>
                </Link>
                <Link to="/residential-softwash-pressurewash" className="service-card" >

                    <img src="/assets/pressureAfter.png" alt="Cleaning a home" />
                    <h2>Residential Soft Wash & Pressure Wash</h2>
                    <p>
                        We offer a variety of residential soft wash and pressure wash services to keep your home looking its best.
                    </p>

                </Link>
                <Link to="/roof-cleaning" className="service-card" >

                    <img src="/assets/roofcleaning.png" alt="A drone cleaning a highrise building" />
                    <h2>Roof Cleaning</h2>
                    <p>
                        Our roof cleaning services will keep your roof looking great and protect your home from damage.
                    </p>

                </Link>
            </div>

            <div className="service-cards-list" data-aos="fade-up" data-aos-delay="100" style={{ marginTop: 40, justifyContent: 'flex-start' }}>
                <Link to="/gutter-cleaning" className="service-card" >
                    <img src="/assets/gutterAfter.png" alt="a gutter cleaning" />
                    <h2>Gutter Cleaning</h2>
                    <p>
                        Our gutter cleaning services will keep your gutters clean and free of debris.
                    </p>
                </Link>

                <div style={{ opacity: 0 }} className="service-card" >
                    <img src="/assets/pressureAfter.png" alt="Cleaning a home" />
                    <h2>Window Cleaning</h2>
                    <p>
                        Our window cleaning services will keep your windows clean and streak-free.
                    </p>
                </div>

                <div style={{ opacity: 0 }} className="service-card" >
                    <img src="/assets/pressureAfter.png" alt="Cleaning a home" />
                    <h2>Driveway Cleaning</h2>
                    <p>
                        Our driveway cleaning services will keep your driveway looking great.
                    </p>
                </div>

            </div>

            <Contact />

            <Footer />

            {/* <MetaTagHandler >
                {() => (
                    <>
                        <title>Poodle</title>
                    </>
                )}
            </MetaTagHandler>  */}
            {/* <NonLodable /> */}

            {/* <h2><ServerCallHandler id={"getDogHusky"} pathway={'getDog'} data={{breed:'husky'}} fetchHandler={'/api'} overwrite={'getDogHusky.src'} /></h2> */}



        </>
    )
}

export default Residential